import { TranscriptLineItem } from './TranscriptLineItem';
/**
 * A request for a transcript of part of the court record.
 * Includes information about the job fulfilling this request.
 */
export class CustomerTranscriptLineItem extends TranscriptLineItem {
}
